// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Marketplace_Container {
    position: relative;
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
}

.Marketplace_Content {
    position: relative;
    flex: 1;
    min-height: 0;
    width: 100%;
    overflow: hidden;
}

.Marketplace_Content:empty {
    display: none;
}

.gif_container {
    position: absolute;
    inset: 0;
    display: flex;
    align-items: center;
    justify-content: center;
}

/* El video es 400×400. El alto va declarado porque, hasta que llegan los
   metadatos, un <video> sin alto mide 300×150 (la relación 2:1 por defecto):
   el loader entraba como 128×64, se pintaba apaisado y saltaba a 128×128
   cuando el navegador leía el tamaño real. */
.gif_video {
    width: 128px;
    height: 128px;
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;IAClB,OAAO;IACP,aAAa;IACb,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;;;6CAG6C;AAC7C;IACI,YAAY;IACZ,aAAa;AACjB","sourcesContent":[".Marketplace_Container {\n    position: relative;\n    width: 100%;\n    height: 100%;\n    display: flex;\n    flex-direction: column;\n}\n\n.Marketplace_Content {\n    position: relative;\n    flex: 1;\n    min-height: 0;\n    width: 100%;\n    overflow: hidden;\n}\n\n.Marketplace_Content:empty {\n    display: none;\n}\n\n.gif_container {\n    position: absolute;\n    inset: 0;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n/* El video es 400×400. El alto va declarado porque, hasta que llegan los\n   metadatos, un <video> sin alto mide 300×150 (la relación 2:1 por defecto):\n   el loader entraba como 128×64, se pintaba apaisado y saltaba a 128×128\n   cuando el navegador leía el tamaño real. */\n.gif_video {\n    width: 128px;\n    height: 128px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
